// Query params that keep the connector dashboard view (tab, filters, sort)
// across a reload. They describe one workspace's view, so the code that
// switches workspace drops them; Back and Forward keep each entry's own view.
export const CONNECTOR_VIEW_PARAMS = {
  tab: 'tab',
  status: 'status',
  auth: 'auth',
  sort: 'sort',
} as const;

export function dropConnectorViewParams(params: URLSearchParams) {
  for (const key of Object.values(CONNECTOR_VIEW_PARAMS)) {
    params.delete(key);
  }
}
